import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/corporate/logo.svg'
import _imports_1 from '@/assets/images/corporate/phone-icon.svg'
import _imports_2 from '@/assets/images/corporate/menu-icon.svg'


const _hoisted_1 = { class: "corp-header" }
const _hoisted_2 = {
  key: 0,
  class: "fullscreen-menu"
}

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CorporateHeader',
  setup(__props) {

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const closeMenu = () => {
  isMenuOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", { class: "header-content" }, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "GLH Inc."
        })
      ], -1)),
      _createElementVNode("div", { class: "header-buttons" }, [
        _cache[1] || (_cache[1] = _createElementVNode("a", {
          href: "tel:03-5324-2316",
          class: "btn-circle btn-orange"
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "電話"
          })
        ], -1)),
        _createElementVNode("button", {
          class: "btn-circle btn-brown",
          onClick: toggleMenu
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_2,
            alt: "メニュー"
          }, null, -1)
        ]))
      ])
    ]),
    (isMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", { class: "menu-header" }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "menu-logo" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "GLH Inc."
              })
            ], -1)),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: closeMenu
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                width: "28",
                height: "28",
                viewBox: "0 0 28 28",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M21 7L7 21M7 7L21 21",
                  stroke: "white",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ]))
          ]),
          _createElementVNode("div", { class: "menu-content" }, [
            _createElementVNode("nav", { class: "menu-nav" }, [
              _createElementVNode("a", {
                href: "#fv",
                onClick: closeMenu
              }, "ホーム"),
              _createElementVNode("a", {
                href: "#recruit",
                onClick: closeMenu
              }, "採用"),
              _createElementVNode("a", {
                href: "#company",
                onClick: closeMenu
              }, "会社概要")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})